import { getAllowedTourKeys } from "../utils/pageTourAccess";

export const PAGE_GUIDE_CATEGORIES = [
  { id: "main", titleKey: "main" },
  { id: "accounts", titleKey: "accounts" },
  { id: "funds", titleKey: "funds" },
  { id: "transactions", titleKey: "transactions" },
  { id: "ib", titleKey: "ib_dashboard" },
  { id: "profile", titleKey: "profile" },
  { id: "settings", titleKey: "settings" },
  { id: "legal", titleKey: "legal" },
  { id: "support", titleKey: "support" },
];

export const PAGE_GUIDES = [
  {
    key: "dashboard",
    path: "/pages/dashboard",
    category: "main",
    icon: "fa-solid fa-house",
    stepCount: 3,
  },
  {
    key: "transaction_flow",
    path: "/pages/dashboard",
    category: "main",
    icon: "fa-solid fa-chart-column",
    stepCount: 1,
  },
  {
    key: "trading_accounts",
    path: "/pages/dashboard",
    category: "main",
    icon: "fa-solid fa-layer-group",
    stepCount: 1,
  },
  {
    key: "marketing_tools",
    path: "/pages/marketing-tools",
    category: "main",
    icon: "fa-solid fa-bullhorn",
    stepCount: 3,
  },
  {
    key: "accounts_list",
    path: "/pages/accounts/list",
    category: "accounts",
    icon: "fa-solid fa-wallet",
    stepCount: 3,
  },
  {
    key: "demo_accounts",
    path: "/pages/accounts/demo",
    category: "accounts",
    icon: "fa-solid fa-flask",
    stepCount: 3,
  },
  {
    key: "add_account",
    path: "/pages/accounts/list",
    category: "accounts",
    icon: "fa-solid fa-plus",
    stepCount: 3,
  },
  {
    key: "account_deposit",
    path: "/pages/accounts/list",
    category: "accounts",
    icon: "fa-solid fa-wallet",
    stepCount: 3,
  },
  {
    key: "account_transfer",
    path: "/pages/accounts/list",
    category: "accounts",
    icon: "fa-solid fa-right-left",
    stepCount: 3,
  },
  {
    key: "account_withdraw",
    path: "/pages/accounts/list",
    category: "accounts",
    icon: "fa-solid fa-arrow-down",
    stepCount: 3,
  },
  {
    key: "account_history",
    path: "/pages/accounts/history",
    openPath: "/pages/accounts/list",
    matchNested: true,
    category: "accounts",
    icon: "fa-solid fa-clock-rotate-left",
    stepCount: 3,
  },
  {
    key: "transfer",
    path: "/pages/transfer",
    category: "funds",
    icon: "fa-solid fa-arrow-right-arrow-left",
    stepCount: 3,
  },
  {
    key: "demo_deposit",
    path: "/pages/demo-deposit",
    category: "funds",
    icon: "fa-solid fa-coins",
    stepCount: 3,
  },
  {
    key: "cash_in",
    path: "/pages/cash-in",
    category: "funds",
    icon: "fa-solid fa-arrow-down",
    stepCount: 3,
  },
  {
    key: "cash_out",
    path: "/pages/cash-out",
    category: "funds",
    icon: "fa-solid fa-arrow-up",
    stepCount: 3,
  },
  {
    key: "exchange",
    path: "/pages/exchange",
    category: "funds",
    icon: "fa-solid fa-rotate",
    stepCount: 3,
  },
  {
    key: "pay_with_card",
    path: "/pages/pay-with-card",
    category: "funds",
    icon: "fa-solid fa-credit-card",
    stepCount: 3,
  },
  {
    key: "cash_in_requests",
    path: "/pages/transactions/cash-in-requests",
    category: "transactions",
    icon: "fa-solid fa-file-arrow-down",
    stepCount: 3,
  },
  {
    key: "cash_out_requests",
    path: "/pages/transactions/cash-out-requests",
    category: "transactions",
    icon: "fa-solid fa-file-arrow-up",
    stepCount: 3,
  },
  {
    key: "pending_transactions",
    path: "/pages/transactions/pending",
    category: "transactions",
    icon: "fa-solid fa-hourglass-half",
    stepCount: 3,
  },
  {
    key: "transactions_history",
    path: "/pages/transactions/history",
    category: "transactions",
    icon: "fa-solid fa-list",
    stepCount: 3,
  },
  {
    key: "ib_dashboard",
    path: "/pages/ibDashboard/dashboard",
    category: "ib",
    icon: "fa-solid fa-chart-line",
    stepCount: 3,
  },
  {
    key: "clients_list",
    path: "/pages/ibDashboard/clients-list",
    category: "ib",
    icon: "fa-solid fa-users",
    stepCount: 3,
  },
  {
    key: "clients_tree",
    path: "/pages/ibDashboard/clients-tree",
    category: "ib",
    icon: "fa-solid fa-sitemap",
    stepCount: 3,
  },
  {
    key: "client_accounts",
    path: "/pages/ibDashboard/client-accounts",
    openPath: "/pages/ibDashboard/clients-list",
    matchNested: true,
    category: "ib",
    icon: "fa-solid fa-user-tag",
    stepCount: 3,
  },
  {
    key: "transfer_to_client",
    path: "/pages/ibDashboard/transfer-to-client",
    category: "ib",
    icon: "fa-solid fa-user-plus",
    stepCount: 3,
  },
  {
    key: "transfer_from_client",
    path: "/pages/ibDashboard/transfer-from-client",
    category: "ib",
    icon: "fa-solid fa-user-minus",
    stepCount: 3,
  },
  {
    key: "collect_transaction",
    path: "/pages/ibDashboard/collect-transaction",
    category: "ib",
    icon: "fa-solid fa-hand-holding-dollar",
    stepCount: 3,
  },
  {
    key: "send_notification",
    path: "/pages/ibDashboard/send-notification",
    category: "ib",
    icon: "fa-solid fa-bell",
    stepCount: 3,
  },
  {
    key: "broker_tools",
    path: "/pages/ibDashboard/broker-tools",
    matchNested: true,
    category: "ib",
    icon: "fa-solid fa-toolbox",
    stepCount: 3,
  },
  {
    key: "profile_information",
    path: "/pages/profile-information",
    category: "profile",
    icon: "fa-solid fa-id-card",
    stepCount: 3,
  },
  {
    key: "trading_information",
    path: "/pages/trading-information",
    category: "profile",
    icon: "fa-solid fa-chart-column",
    stepCount: 3,
  },
  {
    key: "financial_information",
    path: "/pages/financial-information",
    category: "profile",
    icon: "fa-solid fa-building-columns",
    stepCount: 3,
  },
  {
    key: "user_regulation",
    path: "/pages/user-regulation",
    category: "profile",
    icon: "fa-solid fa-scale-balanced",
    stepCount: 3,
  },
  {
    key: "change_pin",
    path: "/pages/settings/change-pin",
    category: "settings",
    icon: "fa-solid fa-key",
    stepCount: 3,
  },
  {
    key: "active_devices",
    path: "/pages/settings/active-devices",
    category: "settings",
    icon: "fa-solid fa-mobile-screen",
    stepCount: 3,
  },
  {
    key: "privacy_policy",
    path: "/pages/legal/privacy-policy",
    category: "legal",
    icon: "fa-solid fa-shield-halved",
    stepCount: 3,
  },
  {
    key: "terms_of_services",
    path: "/pages/legal/terms-of-services",
    category: "legal",
    icon: "fa-solid fa-file-contract",
    stepCount: 3,
  },
  {
    key: "risk_disclosure",
    path: "/pages/legal/risk-disclosure",
    category: "legal",
    icon: "fa-solid fa-triangle-exclamation",
    stepCount: 3,
  },
  {
    key: "faq",
    path: "/pages/support/faq",
    category: "support",
    icon: "fa-solid fa-circle-question",
    stepCount: 3,
  },
  {
    key: "about_us",
    path: "/pages/support/about-us",
    category: "support",
    icon: "fa-solid fa-circle-info",
    stepCount: 3,
  },
];

export function getPageGuideByKey(key) {
  if (!key) return null;
  return PAGE_GUIDES.find((guide) => guide.key === key) || null;
}

export function getPageGuideByPath(pathname) {
  if (!pathname) return null;

  const exact = PAGE_GUIDES.find((guide) => guide.path === pathname);
  if (exact) return exact;

  return (
    PAGE_GUIDES.find(
      (guide) => guide.matchNested && pathname.startsWith(`${guide.path}/`)
    ) || null
  );
}

export function getGuideTitleKey(key) {
  return `guide_${key}_title`;
}

export function getGuideDescKey(key) {
  return `guide_${key}_desc`;
}

export function getGuideStepKey(key, index) {
  return `guide_${key}_step${index}`;
}

const PAGE_TOUR_DETAIL_KEYS = {
  cash_in: ["amount", "account", "method"],
  cash_out: ["amount", "wallet", "method"],
  transfer: ["amount", "from_account", "to_account"],
};

export function getTourDetailFields(guideKey) {
  const fields = PAGE_TOUR_DETAIL_KEYS[guideKey];
  if (!fields) return [];
  return fields.map((field) => ({
    key: field,
    titleKey: `guide_${guideKey}_detail_${field}_title`,
    descKey: `guide_${guideKey}_detail_${field}_desc`,
  }));
}

const TOUR_PAGE_KEYS = [
  "dashboard",
  "transaction_flow",
  "trading_accounts",
  "accounts_list",
  "demo_accounts",
  "add_account",
  "account_deposit",
  "account_transfer",
  "account_withdraw",
  "cash_in",
  "cash_out",
  "transfer",
  "exchange",
  "pay_with_card",
  "cash_in_requests",
  "cash_out_requests",
  "pending_transactions",
  "transactions_history",
  "ib_dashboard",
  "clients_list",
  "clients_tree",
  "transfer_to_client",
  "transfer_from_client",
  "collect_transaction",
  "send_notification",
  "broker_tools",
  "marketing_tools",
  "profile_information",
  "user_regulation",
  "trading_information",
  "financial_information",
  "change_pin",
  "active_devices",
  "privacy_policy",
  "terms_of_services",
  "risk_disclosure",
  "faq",
  "about_us",
];

export const TOUR_SIDEBAR_DROPDOWN = {
  accounts_list: "accounts",
  demo_accounts: "accounts",
  cash_in: "funds",
  cash_out: "funds",
  transfer: "funds",
  exchange: "funds",
  pay_with_card: "funds",
  cash_in_requests: "transactions",
  cash_out_requests: "transactions",
  pending_transactions: "transactions",
  transactions_history: "transactions",
  collect_transaction: "transactions",
  ib_dashboard: "ibDashboard",
  clients_list: "ibDashboard",
  clients_tree: "ibDashboard",
  send_notification: "ibDashboard",
  transfer_to_client: "ibDashboard",
  transfer_from_client: "ibDashboard",
  broker_tools: "marketingTools",
  marketing_tools: "marketingTools",
  profile_information: "profile",
  user_regulation: "profile",
  trading_information: "profile",
  financial_information: "profile",
  change_pin: "settings",
  active_devices: "settings",
  privacy_policy: "legal",
  terms_of_services: "legal",
  risk_disclosure: "legal",
  faq: "support",
  about_us: "support",
};

export const TOUR_FIELD_GUIDES = {
  cash_in: [
    { id: "tabs", labelKey: "guide_cash_in_field_tabs_label", textKey: "guide_cash_in_field_tabs" },
    { id: "amount", labelKey: "guide_cash_in_field_amount_label", textKey: "guide_cash_in_field_amount" },
    { id: "account", labelKey: "guide_cash_in_field_account_label", textKey: "guide_cash_in_field_account" },
    { id: "wallet", labelKey: "guide_cash_in_field_wallet_label", textKey: "guide_cash_in_field_wallet" },
    { id: "method", labelKey: "guide_cash_in_field_method_label", textKey: "guide_cash_in_field_method" },
    { id: "details", labelKey: "guide_cash_in_field_details_label", textKey: "guide_cash_in_field_details" },
    { id: "document", labelKey: "guide_cash_in_field_document_label", textKey: "guide_cash_in_field_document" },
  ],
  cash_out: [
    { id: "amount", labelKey: "guide_cash_out_field_amount_label", textKey: "guide_cash_out_field_amount" },
    { id: "wallet", labelKey: "guide_cash_out_field_wallet_label", textKey: "guide_cash_out_field_wallet" },
    { id: "method", labelKey: "guide_cash_out_field_method_label", textKey: "guide_cash_out_field_method" },
    { id: "phone", labelKey: "guide_cash_out_field_phone_label", textKey: "guide_cash_out_field_phone" },
  ],
  transfer: [
    { id: "amount", labelKey: "guide_transfer_field_amount_label", textKey: "guide_transfer_field_amount" },
    { id: "from", labelKey: "guide_transfer_field_from_label", textKey: "guide_transfer_field_from" },
    { id: "to", labelKey: "guide_transfer_field_to_label", textKey: "guide_transfer_field_to" },
    { id: "summary", labelKey: "guide_transfer_field_summary_label", textKey: "guide_transfer_field_summary" },
  ],
};

function expandGuide(guide) {
  const fields = TOUR_FIELD_GUIDES[guide.key];
  if (!fields?.length) return [guide];
  return fields.map((field) => ({
    ...guide,
    fieldId: field.id,
    titleKey: field.labelKey,
    bodyKey: field.textKey,
  }));
}

export function getTourPages(user) {
  const allowed = getAllowedTourKeys(user);
  return TOUR_PAGE_KEYS.map((key) => getPageGuideByKey(key))
    .filter((guide) => guide && allowed.has(guide.key))
    .flatMap(expandGuide);
}

export function getTourPageIndex(pathname, user) {
  if (!pathname) return -1;

  const pages = getTourPages(user);
  const exactIndex = pages.findIndex((guide) => guide.path === pathname);
  if (exactIndex >= 0) return exactIndex;

  return pages.findIndex(
    (guide) => guide.matchNested && pathname.startsWith(`${guide.path}/`)
  );
}
